import React, {useEffect, useState} from 'react';
import Select from "antd/es/select";
import Form from "antd/es/form";

function SelectActivity({getFieldDecorator, data = {}, handleActivitySearch, activities = [], title = ''}) {
    const [searchedActivities, setSearchedActivities] = useState([])

    useEffect(() => {
        setSearchedActivities(activities)
    }, [activities]);
    return (
        <>
            <Form.Item key={'activityNo'}
                       label={'Select Activities'}>
                {getFieldDecorator('activityNo', {
                    rules: [{
                        required: true, message: 'Activity Number is required!',
                    }],
                    initialValue: (title === 'EDIT') ? (data && data['activityNo']) ? data['activityNo'] : [] : [],
                })(<Select
                    mode="multiple"
                    allowClear
                    onSearch={handleActivitySearch}
                    showSearch={true}
                    showArrow={true}
                    placeholder={'Please Select Activities'}
                    disabled={title === 'EDIT' && true}
                    filterOption={(input, option) => (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0}
                >
                    {searchedActivities && searchedActivities.map((item, index) => {
                        return <Select.Option
                            key={item._id}
                            value={item.activitySerialNo}>
                            {item.activitySerialNo}
                        </Select.Option>
                    })}
                </Select>)}
            </Form.Item>
        </>
    );
}

export default SelectActivity;
